import { AuditAction, AuditActionWhen, AuditSection } from './types';

export type ConditionalAction = AuditAction & { when: Exclude<AuditActionWhen, true> };

/** `when: true` is the section's default route; anything else branches on one question's answer. */
const triggerQuestion = (action: AuditAction): string | undefined =>
  action.when === true ? undefined : action.when.equals[0];

/** The rules a question's own answer triggers. The section owns them, so the question cannot count them itself. */
export const rulesTriggeredBy = (section: AuditSection, questionKey: string): ConditionalAction[] =>
  section.actions.filter((action): action is ConditionalAction => triggerQuestion(action) === questionKey);

/** One pass over a section's actions for the canvas rows, where `rulesTriggeredBy` per row would rescan them per question. */
export const ruleCountsByQuestion = (section: AuditSection): Map<string, number> => {
  const counts = new Map<string, number>();
  section.actions.forEach((action) => {
    const questionKey = triggerQuestion(action);
    if (questionKey !== undefined) {
      counts.set(questionKey, (counts.get(questionKey) ?? 0) + 1);
    }
  });
  return counts;
};
